<template>
  <div id="InwardStock">
    <v-container fluid class="fill-height">
      <v-row>
        <v-col cols="3">
          <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                  transition="scale-transition" v-model="orderDateMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="Order Date*" outlined dense prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                            v-model="orderDateFormat" v-on="on"></v-text-field>
            </template>
            <v-date-picker @input="orderDateMenu = false" v-model="orderDate"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <v-text-field label="Ref. Order Number" v-model="remark" dense outlined></v-text-field>
        </v-col>
        <!--<v-spacer></v-spacer>-->
        <v-col cols="2" class="text-left">
          <v-btn @click="saveInwardStock" class="primary" text>SAVE</v-btn>
          <v-btn @click="$emit('cancel')"  class="ml-3" text>CANCEL</v-btn>
        </v-col>
      </v-row>
      <v-card outlined width="100%"
              style="max-height: 85.0vh; min-height: 85.5vh; overflow-y: auto; overflow-x: hidden">
        <v-card class="py-0" :key="index" v-for="(price,index) in prices" elevation="0">
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="2" class="text-center">
                <v-img class="d-block mx-auto" :src="price.Product.image?price.Product.image:'../src/assets/logo.png'"
                       contain width="50"></v-img>
                <v-chip label text-color="white" x-small v-if="price.Product.packageType" class="mt-3"
                        :style="`background-color: ${packageColor[price.Product.packageType]}`">
                  {{ price.Product.packageType.toUpperCase() }}
                </v-chip>
              </v-col>
              <v-col cols="8">
                <h6 class="text-subtitle-1 font-weight-bold" :style="{color:price.Product.colorCode}">
                  {{ price.Product.displayName }} ({{ price.Product.weight }} gm)</h6>
                <p class="text-caption font-italic mb-0">{{ price.Product.bunchKg }} Pieces in Box</p>
              </v-col>

              <v-col cols="2" class="d-flex">
                <div class="mr-3">
                  <p class="mb-0 text-caption">Boxes</p>
                  <v-text-field style="width: 100px;" class="text-center stock-field" append-icon="mdi-plus" dense flat
                                hide-details outlined prepend-inner-icon="mdi-minus"
                                @click:prepend-inner="decreaseQuantity(index)" @click:append="increaseQuantity(index)"
                                v-model="price.Product.quantity"></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-container>
    <Snackbar :toaster="toaster"></Snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import { GET_ALL_PRICES_AND_PRODUCTS } from '@/graphql/queries/Products'
import { IDS } from '@/Constants/IDS'
import { GET_ORGANIZATION_DUE_BY_ID, GET_ORGANIZATION_STOCK_INWARD } from '@/graphql/queries/OrganizationStock'
import { CREATE_UPDATE_ORDER_ORDER_ITEMS, CREATE_UPDATE_ORGANIZATION_STOCK } from '@/graphql/mutations/OrderStock'
import NetworkCommunicator from '@/plugins/NetworkResourceHandler'
import Constants from '@/Constants/Constants'
import Snackbar from '@/components/Common/Snackbar'

export default {
  name: 'InwardStock',
  components: { Snackbar },
  data () {
    return {
      orderDateMenu: false, orderDate: moment().format('YYYY-MM-DD'), remark: null,
      user: JSON.parse(localStorage.user),
      toId: null, fromId: null, userId: null,
      prices: [], toaster: {},
    }
  },
  apollo: {
    Prices: {
      query: GET_ALL_PRICES_AND_PRODUCTS, fetchPolicy: 'network-only',
      variables () {
        return { priceListId: this.user.organization.priceListId, unitId: IDS.unitType.Box }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.prices = JSON.parse(JSON.stringify(data.Prices))
          this.prices.forEach(price => { price.Product['quantity'] = 0 })
          this.$forceUpdate()
        }
      },
    },
  },
  mounted () {
    this.userId = this.user.id
    this.toId = this.user.organization.id
    this.fromId = this.user.organization.parentOrgId
        ? this.user.organization.parentOrgId
        : IDS.organizations.RAJ_WAFERS_MASTER
  },
  methods: {
    increaseQuantity (index) {
      if (parseInt(this.prices[index].Product.quantity)) {
        this.prices[index].Product.quantity = parseInt(this.prices[index].Product.quantity) + 1
      } else { this.prices[index].Product.quantity = 1 }
      this.$forceUpdate()
    },
    decreaseQuantity (index) {
      if (parseInt(this.prices[index].Product.quantity)) {
        this.prices[index].Product.quantity = parseInt(this.prices[index].Product.quantity) - 1
        this.$forceUpdate()
      }
    },
    async saveInwardStock () {
      if (this.calculateQuantity()) {
        let fromOrgStock = [], updateFromOrgStock = []
        let toOrgStock = [], updateToOrgStock = []
        let response = await this.$apollo.query({
          query: GET_ORGANIZATION_DUE_BY_ID, fetchPolicy: 'network-only',
          variables: { id: this.toId },
        })
        if (response.data) {
          let res = await this.$apollo.query({
            query: GET_ORGANIZATION_STOCK_INWARD, fetchPolicy: 'network-only',
            variables: { toId: this.toId, fromId: this.fromId, unitId: IDS.unitType.Box },
          })
          if (res.data) {
            fromOrgStock = res.data.FromOrganizationStock
            toOrgStock = res.data.ToOrganizationStock
            let orderItems = []
            this.prices.forEach(price => {
              if (parseInt(price.Product.quantity)) {
                let obj = {
                  from: this.fromId, to: this.toId, perUnitPrice: price.price.toString(),
                  productId: price.Product.id, quantity: price.Product.quantity,
                  price: parseInt(price.Product.quantity) * price.price,
                  createdBy: this.userId, updatedBy: this.userId,
                }
                orderItems.push(obj)
              }
            })
            let totalOrderItemPrice = orderItems.reduce((prev, next) => prev + next.price, 0)
            let withGst = totalOrderItemPrice + (0.05 * totalOrderItemPrice)
            let orderObj = {
              date: moment(this.orderDate, 'YYYY-MM-DD').format(),
              orderItemCount: orderItems.length,
              status: IDS.orderStatus.Delivered,
              from: this.fromId, to: this.toId,
              gstPrice: '5%',
              colloectedAmount: Math.round(withGst),//final price
              price: totalOrderItemPrice, //order item total
              finalPrice: Math.round(withGst), // round of gst
              previousDueAmount: response.data.Organizations[0].totalDueAmount,
              roundOfValue: withGst, // with gst float
              remark: this.remark,
              createdBy: this.userId, updatedBy: this.userId,
            }
            orderItems.forEach(orderItem => {
              let fromObj = fromOrgStock.find(fromStock => fromStock.productId === orderItem.productId)
              let toObj = toOrgStock.find(toStock => toStock.productId === orderItem.productId)
              let updateFromObj = {}
              let updateToObj = {}
              if (fromObj) {
                updateFromObj['id'] = fromObj.id
                updateFromObj['organizationId'] = fromObj.organizationId
                updateFromObj['productId'] = fromObj.productId
                updateFromObj['quantity'] = parseInt(fromObj.quantity) - parseInt(orderItem.quantity)
                updateFromObj['unitId'] = fromObj.unitId
              } else {
                updateFromObj['organizationId'] = this.fromId
                updateFromObj['productId'] = orderItem.productId
                updateFromObj['quantity'] = 0 - parseInt(orderItem.quantity)
                updateFromObj['unitId'] = IDS.unitType.Box
              }
              if (toObj) {
                updateToObj['id'] = toObj.id
                updateToObj['organizationId'] = toObj.organizationId
                updateToObj['productId'] = toObj.productId
                updateToObj['quantity'] = parseInt(toObj.quantity) + parseInt(orderItem.quantity)
                updateToObj['unitId'] = toObj.unitId
              } else {
                updateToObj['organizationId'] = this.toId
                updateToObj['productId'] = orderItem.productId
                updateToObj['quantity'] = parseInt(orderItem.quantity)
                updateToObj['unitId'] = IDS.unitType.Box
              }
              updateFromOrgStock.push(updateFromObj)
              updateToOrgStock.push(updateToObj)
            })
            orderObj['OrderItems'] = { data: orderItems }
            let orders_on_conflict_rule = {
              constraint: 'Orders_pkey',
              update_columns: [
                'date',
                'orderItemCount',
                'status',
                'lastUpdatedOn',
                'lastStatusUpdatedOn',
                'lastStatusUpdatedBy',
                'gstPrice',
                'gstObject',
                'colloectedAmount',
                'price',
                'finalPrice',
                'previousDueAmount',
                'roundOfValue'],
            }
            let res1 = await this.$apollo.mutate({
              mutation: CREATE_UPDATE_ORDER_ORDER_ITEMS,
              variables: { orderObj: orderObj, orders_on_conflict_rule: orders_on_conflict_rule },
            })
            if (res1.data) {
              let organizationStock_on_conflict_rule = {
                constraint: 'OrganizationStock_pkey',
                update_columns: ['locationId', 'productId', 'unitId', 'quantity', 'totalQuantityInPackets'],
              }
              let res2 = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_ORGANIZATION_STOCK,
                variables: {
                  updateFromOrgStock: updateFromOrgStock, updateToOrgStock: updateToOrgStock,
                  organizationStock_on_conflict_rule: organizationStock_on_conflict_rule,
                },
              })
              if (res2.data) {
                let postData = {
                  customerOrganizationId: this.toId, organizationId: this.fromId,
                  amount: orderObj.colloectedAmount, type: 'Credit',
                  createdBy: this.userId, collectedBy: this.userId,
                  vehicleTripId: null,
                }
                NetworkCommunicator('POST', `${Constants.api_url}addCreditEntry`, postData).then(res3 => {
                  if (res3.data) {
                    this.toaster = { color: 'green', enable: true, message: 'Stock Inward Successfully Done' }
                    let self = this
                    setTimeout(() => {self.$emit('cancel')}, 1000)
                  }
                })
              }
            }
          }
        }
      } else {
        this.toaster = { enable: true, message: 'Please select any stock', color: 'red' }
      }
    },
    calculateQuantity () {
      let total = 0
      this.prices.forEach(price => {
        total += parseInt(price.Product?.quantity)
      })
      return total
    },
  },
  computed: {
    orderDateFormat () {
      return this.orderDate ? moment(this.orderDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : null
    },
  },
}
</script>

<style scoped>
.PartyPack {
  background-color: #EC2144 !important;
}

.FamilyPack {
  background-color: #DAB44F !important;
}

.CouplePack {
  background-color: #45B1E6 !important;
}
</style>
